import React from 'react';
import { makeBtStyles } from '../Theme';

import { Branding } from '../components/DataProviders';
import ThemeProvider from '../Theme';
import PoweredBy from '../components/PoweredBy';
import GiftWrapPanel from '../components/GiftWrapPanel';

import AppBar from './AppBar';
import MainCard from './MainCard';
import TrackingCard from './TrackingCard';
import LineItemsCard from './LineItemsCard';
import ContactCard from './ContactCard';

import { CONTENT_WIDTH, MOBILE_CONTENT_WIDTH } from '../components/defaultStyleVars';


const useStyles = makeBtStyles( theme => ({
  giftWrapPanel: {
    margin: '30px auto',
    width: `${CONTENT_WIDTH}px`,
    [theme.breakpoints.down('sm')]: {
      width: MOBILE_CONTENT_WIDTH,
      margin: '30px auto',
      display: 'block'
    }
  },
  cardGrid: {
    margin: '30px auto',
    width: `${CONTENT_WIDTH}px`,
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      margin: '30px 0',
      display: 'block'
    }
  },
  mainCard: {
    width: '307px',
    [theme.breakpoints.down('sm')]: {
      width: MOBILE_CONTENT_WIDTH,
      height: 'auto',
      minWidth: '270px',
      margin: '30px auto'
    }
  },
  secondaryCard: {
    width: '254px',
    marginLeft: '16px',
    [theme.breakpoints.down('sm')]: {
      width: MOBILE_CONTENT_WIDTH,
      height: 'auto',
      minWidth: '270px',
      margin: '30px auto'
    }
  }
}));


function Layout01({ branding }:{
  branding: Branding
}) {
  const { colors } = branding;
  const classes = useStyles();

  const themeOverrides = {
    page: { background: colors && colors.secondary },
    link: { color: colors && colors.tertiary },
    estimatedDeliveryDateOrStatus: { color: colors && colors.primary }
  };

  return (
    <ThemeProvider configOverrides={themeOverrides}>
      <div data-testid="layout01">
        <AppBar />
        <GiftWrapPanel className={classes.giftWrapPanel} />
        <div className={classes.cardGrid}>
          <MainCard className={classes.mainCard} />
          <TrackingCard className={classes.secondaryCard} />
          <LineItemsCard className={classes.secondaryCard} />
          <ContactCard className={classes.secondaryCard} />
        </div>
      </div>
      <PoweredBy />
    </ThemeProvider>
  );
}

export default Layout01;